import { render, staticRenderFns } from "./SidebarRangesStyleRows.vue?vue&type=template&id=18be508e&scoped=true&"
import script from "./SidebarRangesStyleRows.vue?vue&type=script&lang=js&"
export * from "./SidebarRangesStyleRows.vue?vue&type=script&lang=js&"
import style0 from "./SidebarRangesStyleRows.vue?vue&type=style&index=0&id=18be508e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be508e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
